import Api from '@/api/index';

const Payment = {
  namespaced: true,
  state: {
    allPayments: [],
    statusByTitle:{}
  },
  getters: {
    
  },

  mutations: {
    setAllPayments(state, payments) {
      state.allPayments = [...payments]
      
    }

    // this.status_missed_id = state.allPayments.find(s=>s.title == 'Missed').id
    // this.status_bacon_id = state.allPayments.find(s=>s.title == 'Bacon').id
  },

  actions: {
    index(context, filters) {
      return Api.Payment.index(filters).then(r => r.data).then(r => {
        context.commit('setAllPayments', r)
        return true
      }).catch(err => {
        console.log(err)
        throw Error(err)
      })
    }
  }

};

export default Payment;
